﻿/*************** HEADER SUB MENU ALIGNMENT START *********************/
function desktopSubmenuAlignHandler() {
    // Kun på desktop
    if (!window.matchMedia("(min-width: 769px)").matches) return;

    const headerMenu = document.querySelector('.header-menu');
    if (!headerMenu) return;

    const wrappers = headerMenu.querySelectorAll(':scope > .dropdown-item > .sub-menu-wrapper');
    if (!wrappers.length) return;

    const headerRect = headerMenu.getBoundingClientRect();
    if (!headerRect.width) { requestAnimationFrame(desktopSubmenuAlignHandler); return; }

    // top-level LI relativ
    headerMenu.querySelectorAll(':scope > .dropdown-item').forEach(li => { li.style.position = 'relative'; });

    wrappers.forEach(wrapper => {
        const parent = wrapper.closest('.dropdown-item');
        if (!parent) return;

        // grid (med/uden .submenu-inner)
        let grid = wrapper.querySelector(':scope > .submenu-inner > .header-sub-menu, :scope > .header-sub-menu');
        if (!grid) return;

        // sikre .submenu-inner
        let inner = wrapper.querySelector(':scope > .submenu-inner');
        if (!inner) {
            inner = document.createElement('div');
            inner.className = 'submenu-inner';
            inner.appendChild(grid);
            wrapper.appendChild(inner);
            grid = inner.querySelector(':scope > .header-sub-menu');
            if (!grid) return;
        }

        // === Fuldbredde wrapper uden scrollbar ===
        const parentRect = parent.getBoundingClientRect();
        const vwNoScrollbar = document.documentElement.clientWidth; // undgår 100vw-problem
        wrapper.style.right = 'auto';
        wrapper.style.left = `${-parentRect.left}px`;
        wrapper.style.width = `${vwNoScrollbar}px`;
        wrapper.style.background = '#fff';

        // indhold matcher headerens bredde/placering
        inner.style.width = `${headerRect.width}px`;
        inner.style.marginLeft = `${headerRect.left}px`;
        inner.style.marginRight = 'auto';

        // === Kolonnelogik ===
        const sections = grid.querySelectorAll(':scope > li.dropdown-item > .sub-menu-wrapper').length;

        if (sections === 0) {
            // Simple liste → 1 kolonne
            grid.classList.add('is-single-col');
            grid.classList.remove('is-mega');
            grid.removeAttribute('data-cols');

            grid.style.display = 'grid';
            grid.style.width = '100%';
            grid.style.margin = '0';
            grid.style.columnGap = '0';
            grid.style.setProperty('grid-template-columns', '1fr', 'important');

            Array.from(grid.children).forEach(el => el.classList.remove('is-last-col'));
            return;
        }

        // Mega: min 2, max 6
        const MEGA_MAX_COLS = 6;
        const cols = Math.max(2, Math.min(MEGA_MAX_COLS, sections));

        grid.classList.remove('is-single-col');
        grid.classList.add('is-mega');
        grid.setAttribute('data-cols', String(cols));

        grid.style.display = 'grid';
        grid.style.width = '100%';
        grid.style.margin = '0';
        grid.style.columnGap = '0';
        grid.style.setProperty('grid-template-columns', `repeat(${cols}, 1fr)`, 'important');

        const items = Array.from(grid.children);
        items.forEach(el => el.classList.remove('is-last-col'));
        items.forEach((el, idx) => { if ((idx + 1) % cols === 0) el.classList.add('is-last-col'); });
    });
}

// init (desktop)
desktopSubmenuAlignHandler();
window.addEventListener('load', desktopSubmenuAlignHandler);
/*************** HEADER SUB MENU ALIGNMENT END *********************/


/*************** BACKDROP (kun under header) ***************/
let _underlayEl = null;

function ensureUnderlay() {
    if (_underlayEl) return _underlayEl;
    _underlayEl = document.createElement('div');
    _underlayEl.className = 'header-underlay';
    document.body.appendChild(_underlayEl);

    _underlayEl.addEventListener('click', () => {
        document.querySelectorAll('.header-menu > .dropdown-item.hovered').forEach(d => d.classList.remove('hovered'));
        document.querySelectorAll('.header-menu > .dropdown-item > .sub-menu-wrapper.expanded').forEach(w => w.classList.remove('expanded'));
        disableBackdrop();
    });

    return _underlayEl;
}

function positionUnderlay() {
    const header = document.querySelector('.top-navigation');
    const el = ensureUnderlay();
    if (!header) { el.style.top = '0px'; return; }
    const rect = header.getBoundingClientRect();
    const top = rect.bottom + window.scrollY;
    el.style.top = `${top}px`;
}

function enableBackdrop(isMobile = false) {
    const el = ensureUnderlay();
    positionUnderlay();
    el.classList.toggle('is-mobile', !!isMobile);
    el.classList.add('is-visible');

    // NEW: toggl klasse til ren CSS-streg når dropdown er åben
    document.body.classList.add('menu-open');
}

function disableBackdrop() {
    if (_underlayEl) _underlayEl.classList.remove('is-visible', 'is-mobile');

    // NEW: fjern klasse når dropdown lukkes
    document.body.classList.remove('menu-open');
}

// anti-flicker
let _hideBackdropTimer = null;
function showBackdropNow(isMobile = false) { clearTimeout(_hideBackdropTimer); enableBackdrop(isMobile); }
function maybeHideBackdropSoon(delay = 140) {
    clearTimeout(_hideBackdropTimer);
    _hideBackdropTimer = setTimeout(() => {
        const anyOpen = document.querySelector('.header-menu > .dropdown-item.hovered');
        if (!anyOpen) disableBackdrop();
    }, delay);
}

function repositionIfVisible() {
    if (_underlayEl && _underlayEl.classList.contains('is-visible')) positionUnderlay();
}
window.addEventListener('scroll', repositionIfVisible, { passive: true });
window.addEventListener('resize', repositionIfVisible);
/*************** BACKDROP SLUT ***************/


/*************** HEADER MENU TOUCH SCREEN FIX (>???px) START ***************/
const isTouch = () =>
    'ontouchstart' in window ||
    (window.DocumentTouch && document instanceof window.DocumentTouch) ||
    navigator.maxTouchPoints > 0 ||
    window.navigator.msMaxTouchPoints > 0;

let _touchFixApplied = false;

function touchScreenMenuFix() {
    const MQ = '(min-width: 769px)';
    const firstLevel = document.querySelectorAll('.header-menu > .dropdown-item');
    if (!firstLevel.length || !isTouch()) return;

    const pairs = [];
    firstLevel.forEach(dd => {
        const link = dd.querySelector('a')?.getAttribute('href') || '#';
        pairs.push({ dropDown: dd, link });
    });

    const apply = () => {
        if (window.matchMedia(MQ).matches) {
            if (!_touchFixApplied) { addTouchFix(pairs); _touchFixApplied = true; }
        } else if (_touchFixApplied) {
            removeTouchFix(pairs);
            _touchFixApplied = false;
        }
    };

    apply();
    window.addEventListener('resize', apply);
}

function addTouchFix(dropdownLinksArray) {
    dropdownLinksArray.forEach(el => {
        el.dropDown.removeEventListener('mouseenter', hoverMenuItem);
        el.dropDown.removeEventListener('mouseleave', unHoverMenuItem);

        let dropdownHref = el.dropDown.querySelector('a');
        dropdownHref.setAttribute('data-href', el.link);
        dropdownHref.removeAttribute('href');

        el.dropDown.addEventListener('click', touchToggleSubMenu);
    });

    document.addEventListener('click', touchFixCloseSubmenu);
}

function removeTouchFix(dropdownLinksArray) {
    dropdownLinksArray.forEach(el => {
        el.dropDown.addEventListener('mouseenter', hoverMenuItem);
        el.dropDown.addEventListener('mouseleave', unHoverMenuItem);
        el.dropDown.removeEventListener('click', touchToggleSubMenu);

        let dropdownHref = el.dropDown.querySelector('a');
        dropdownHref.setAttribute('href', el.link);
        dropdownHref.removeAttribute('data-href');
    });

    document.removeEventListener('click', touchFixCloseSubmenu);
}

function touchFixCloseSubmenu(event) {
    const dropdown = document.querySelector('.header-menu > .dropdown-item.hovered');
    const openedSubmenu = document.querySelector('.header-menu > .dropdown-item > .sub-menu-wrapper.expanded');
    if (dropdown) dropdown.classList.remove('hovered');
    if (openedSubmenu) openedSubmenu.classList.remove('expanded');
    disableBackdrop();
    event.stopPropagation();
}

function touchToggleSubMenu(event) {
    const dropDownItem = event.target.closest('.header-menu > .dropdown-item');
    if (!dropDownItem) return;
    const submenu = dropDownItem.querySelector('.sub-menu-wrapper');
    if (!submenu) return;

    const firstLevel = document.querySelectorAll('.header-menu > .dropdown-item');
    firstLevel.forEach(d => {
        d.classList.remove('hovered');
        const w = d.querySelector('.sub-menu-wrapper');
        if (w) w.classList.remove('expanded');
    });

    dropDownItem.classList.toggle('hovered');
    submenu.classList.toggle('expanded');

    const isOpen = dropDownItem.classList.contains('hovered');
    if (isOpen) enableBackdrop(false); else disableBackdrop();

    event.stopPropagation();
}

touchScreenMenuFix();
/*************** HEADER MENU TOUCH SCREEN FIX END *********************/


function setMenuListeners() {
    const navbarButtonToggle = document.querySelector("[data-navibar-header-toggle]");
    const navbar = document.querySelector("[data-navibar]");
    const NAVBAR_OPEN_CLASS = "is-open";

    if (navbar && navbarButtonToggle) {
        window.addEventListener("click", () => {
            const wasOpen = navbar.classList.contains(NAVBAR_OPEN_CLASS);
            navbar.classList.remove(NAVBAR_OPEN_CLASS);
            navbarButtonToggle.classList.remove(NAVBAR_OPEN_CLASS);
            if (wasOpen) disableBackdrop();
        });

        navbarButtonToggle.addEventListener("click", (e) => {
            e.stopPropagation();
            navbar.classList.toggle(NAVBAR_OPEN_CLASS);
            navbarButtonToggle.classList.toggle(NAVBAR_OPEN_CLASS);

            const isOpen = navbar.classList.contains(NAVBAR_OPEN_CLASS);
            if (isOpen) {
                enableBackdrop(true);
                // Sørg for at valgt gren åbnes når drawer vises
                requestAnimationFrame(preselectedMenuItemHandler);
            } else {
                disableBackdrop();
            }
        });
    }

    if (navbar) {
        navbar.addEventListener("click", (e) => {
            const isOpened = navbar.classList.contains(NAVBAR_OPEN_CLASS);
            if (isOpened) e.stopPropagation();
        });
    }
}

const subMenuTogglers = document.querySelectorAll('.header-menu .dropdown-item');
if (subMenuTogglers.length !== 0) {
    subMenuTogglers.forEach(toggler => {
        toggler.addEventListener('click', shopDropDownMenu);
    });
}

function shopDropDownMenu(event) {
    if (event.target.classList.contains('caret')) {
        event.preventDefault();
        const currentDropdownItem = event.target.closest('.dropdown-item');
        const submenuWrapper = currentDropdownItem.querySelector('.sub-menu-wrapper');
        currentDropdownItem.classList.toggle('active');
        submenuWrapper.classList.toggle('expanded');
    }
    event.stopPropagation();
}

// Desktop hover
function subMenuToggleDt() {
    const subMenuTogglersDt = document.querySelectorAll('.header-menu > .dropdown-item');
    if (!subMenuTogglersDt.length) return;
    if (window.matchMedia("(min-width: 769px)").matches) {
        subMenuTogglersDt.forEach(toggler => {
            toggler.addEventListener('mouseenter', hoverMenuItem);
            toggler.addEventListener('mouseleave', unHoverMenuItem);
        });
    }
}

function hoverMenuItem(event) {
    const li = event.currentTarget || event.target;
    li.classList.add('hovered');
    li.querySelector('.sub-menu-wrapper')?.classList.add('expanded');
    showBackdropNow(false);
}

function unHoverMenuItem(event) {
    const li = event.currentTarget || event.target;
    li.classList.remove('hovered');
    li.querySelector('.sub-menu-wrapper')?.classList.remove('expanded');
    maybeHideBackdropSoon(140);
}

function touchFixCloseSubmenu(event) {
    document.querySelectorAll('.header-menu > .dropdown-item.hovered').forEach(d => d.classList.remove('hovered'));
    document.querySelectorAll('.header-menu > .dropdown-item > .sub-menu-wrapper.expanded').forEach(w => w.classList.remove('expanded'));
    maybeHideBackdropSoon(0);
    event.stopPropagation();
}

subMenuToggleDt();
setMenuListeners();

/*************** PRESELECTED ITEM (MOBILE) ***********************/
function preselectedMenuItemHandler() {
    if (!window.matchMedia("(max-width: 768px)").matches) return;

    const preselectedItem = document.querySelector('.header-menu .current_page_item');
    if (!preselectedItem) return;

    // Gå op gennem forfædre og åbn alle wrappers
    let parent = preselectedItem.closest('.sub-menu-wrapper');

    if (!parent) {
        const currentSubmenuWrapper = preselectedItem.querySelector('.sub-menu-wrapper');
        if (currentSubmenuWrapper) {
            preselectedItem.classList.add('active');
            currentSubmenuWrapper.classList.add('expanded');
        }
        return;
    }

    while (parent !== null) {
        const dropdownItem = parent.closest('.dropdown-item');
        if (dropdownItem) dropdownItem.classList.add('active');

        parent.classList.add('expanded');
        parent = parent.parentNode?.closest?.('.sub-menu-wrapper') || null;
    }

    const preselectedItemSubMenu = preselectedItem.querySelector('.sub-menu-wrapper');
    if (preselectedItemSubMenu) {
        preselectedItem.classList.add('active');
        preselectedItemSubMenu.classList.add('expanded');
    }
}

// Kør ved initial mobil-load
if (window.matchMedia("(max-width: 768px)").matches) {
    requestAnimationFrame(preselectedMenuItemHandler);
}

// Kør igen når vi krydser breakpoint til mobil (fx i DevTools)
const mqMobile = window.matchMedia("(max-width: 768px)");
if (mqMobile.addEventListener) {
    mqMobile.addEventListener('change', (e) => {
        if (e.matches) {
            requestAnimationFrame(preselectedMenuItemHandler);
            setTimeout(preselectedMenuItemHandler, 120); // efter reflow
        } else {
            // tilbage til desktop → re-align
            requestAnimationFrame(desktopSubmenuAlignHandler);
        }
    });
} else if (mqMobile.addListener) {
    // Safari fallback
    mqMobile.addListener((e) => {
        if (e.matches) {
            requestAnimationFrame(preselectedMenuItemHandler);
            setTimeout(preselectedMenuItemHandler, 120);
        } else {
            requestAnimationFrame(desktopSubmenuAlignHandler);
        }
    });
}
/*************** PRESELECTED ITEM SLUT *************************/


/*************** MENU LAYOUT SHIFT HANDLER ***********************/
function headerMenuResizeHandler() {
    const WIDTH_BREAKPOINT = 768;
    const subMenus = document.querySelectorAll('.header-sub-menu');
    const subMenuWrappers = document.querySelectorAll('.sub-menu-wrapper');
    if (!subMenuWrappers.length || !subMenus.length) return;

    window.addEventListener('resize', () => {
        if (window.innerWidth <= WIDTH_BREAKPOINT) {
            removeHoveringOnMenuItem();
            subMenus.forEach(s => s.removeAttribute('style'));
            subMenuWrappers.forEach(w => w.removeAttribute('style'));

            // NYT: fjern desktop-injicerede styles på .submenu-inner
            document.querySelectorAll('.submenu-inner').forEach(inner => {
                inner.removeAttribute('style'); // fjerner margin-left/width fra desktop
            });

            preselectedMenuItemHandler();               // straks
            setTimeout(preselectedMenuItemHandler, 80); // efter reflow
            disableBackdrop();
        } else {
            desktopSubmenuAlignHandler();
            removeHoveringOnMenuItem();
            subMenuToggleDt();
            subMenuWrappers.forEach(w => w.classList.remove('expanded'));
            disableBackdrop();
        }
    });
}

headerMenuResizeHandler();

function removeHoveringOnMenuItem() {
    const subMenuTogglersDt = document.querySelectorAll('.header-menu > .dropdown-item');
    if (!subMenuTogglersDt.length) return;
    subMenuTogglersDt.forEach(toggler => {
        toggler.removeEventListener('mouseenter', hoverMenuItem);
        toggler.removeEventListener('mouseleave', unHoverMenuItem);
    });
}
/*************** MENU LAYOUT SHIFT HANDLER SLUT ***********************/
